import { MARKETING_PRODUCT_INTEGRATIONS } from "~/lib/inbound-gpt/paths";
import { WORDPRESS_PLUGIN_HREF } from "~/lib/siteglue/landing-redesign/copy";

export type IntegrationNavStatus = "available" | "request";

export type IntegrationNavItem = {
  id: string;
  label: string;
  href: string;
  description: string;
  status: IntegrationNavStatus;
};

export type IntegrationNavSection = {
  id: string;
  label: string;
  items: readonly IntegrationNavItem[];
};

const INTEGRATIONS_HREF = MARKETING_PRODUCT_INTEGRATIONS;
const REQUEST_HREF = MARKETING_PRODUCT_INTEGRATIONS;

/** Header Integrations mega menu. Available = confirmed MCP or WordPress plugin. */
export const SITEGLUE_INTEGRATIONS_NAV: readonly IntegrationNavSection[] = [
  {
    id: "website",
    label: "Website",
    items: [
      {
        id: "wordpress",
        label: "WordPress",
        href: WORDPRESS_PLUGIN_HREF,
        description: "Publish supported ARO files. No WordPress admin passwords in chat.",
        status: "available",
      },
    ],
  },
  {
    id: "scheduling",
    label: "Scheduling",
    items: [
      {
        id: "calendly",
        label: "Calendly",
        href: INTEGRATIONS_HREF,
        description: "List event types, check times, and create invitees.",
        status: "available",
      },
      {
        id: "google-calendar",
        label: "Google Calendar",
        href: INTEGRATIONS_HREF,
        description: "Check availability and create calendar events.",
        status: "available",
      },
      {
        id: "zoom",
        label: "Zoom",
        href: INTEGRATIONS_HREF,
        description: "Add Zoom meeting links on bookings when configured.",
        status: "available",
      },
    ],
  },
  {
    id: "healthcare",
    label: "Healthcare",
    items: [
      {
        id: "nexhealth",
        label: "NexHealth",
        href: INTEGRATIONS_HREF,
        description: "Patient lookup, provider availability, and booking.",
        status: "available",
      },
      {
        id: "juvonno",
        label: "Juvonno",
        href: INTEGRATIONS_HREF,
        description: "Patient lookup, practitioner availability, book, reschedule, and cancel.",
        status: "available",
      },
      {
        id: "opendental",
        label: "Open Dental",
        href: REQUEST_HREF,
        description: "Not a confirmed SiteGlue MCP today. Request a custom integration.",
        status: "request",
      },
    ],
  },
  {
    id: "crm",
    label: "CRM",
    items: [
      {
        id: "hubspot",
        label: "HubSpot",
        href: REQUEST_HREF,
        description: "Not a confirmed SiteGlue MCP today. Request a custom integration.",
        status: "request",
      },
      {
        id: "salesforce",
        label: "Salesforce",
        href: REQUEST_HREF,
        description: "Not a confirmed SiteGlue MCP today. Request a custom integration.",
        status: "request",
      },
      {
        id: "zoho-crm",
        label: "Zoho CRM",
        href: REQUEST_HREF,
        description: "Not a confirmed SiteGlue MCP today. Request a custom integration.",
        status: "request",
      },
    ],
  },
] as const;

export const SITEGLUE_INTEGRATIONS_SEE_ALL_HREF = INTEGRATIONS_HREF;
export const SITEGLUE_INTEGRATIONS_NAV_LABEL = "Integrations";
